import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { CleanFilterBtn } from "../doc-lib-components/Views/Filters-styles";
import MembersContext from "../../../application/Context/MembersContext";
import { useTranslation } from "react-i18next";
export var CleanFilters = function () {
    var _a = React.useContext(MembersContext), resetFilters = _a.resetFilters, filtersIsLoading = _a.filtersIsLoading;
    var t = useTranslation(['news']).t;
    var handleReset = function () {
        resetFilters(false); // Reset partiel mais force la mise à jour
    };
    return (!filtersIsLoading ? _jsxs(CleanFilterBtn, { onClick: handleReset, children: [" ", t("Effacer les filtres")] }) : _jsx("div", { className: "spinner-border spinner-border-sm", role: "status" }));
};
